var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lock-screen-btn-con",on:{"click":_vm.lockScreen}},[_c('Tooltip',{attrs:{"content":_vm.$_t().main.lock,"placement":"bottom"}},[_c('Icon',{attrs:{"type":"md-lock","size":20}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }